// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zj9L","col":"styles_col__1W8Ou","actions":"styles_actions__1x1Bp","conflict":"styles_conflict__1n4pK"};